export const IMAGE_HEIGHT = 200;
export const MODAL_HEIGHT = 600;
export const CONTENT_OVERLAP = 150;
export const MODAL_WIDTH = 600;
